import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'service-request',
      component: () => import('./views/ServiceRequest.vue')
    },
    {
      path: '/success',
      name: 'success',
      component: () => import('./views/Success.vue')
    },
    {
      path: '/status/:id',
      name: 'status',
      component: () => import('./views/Status.vue')
    },
    {
      path: '/warranty',
      component: () => import('./views/warranty/Index.vue'),
      children: [
        {
          path: 'step-1',
          name: 'wstep-1',
          component: () => import('./views/warranty/Step1.vue')
        },
        {
          path: 'step-2',
          name: 'wstep-2',
          component: () => import('./views/warranty/Step2.vue')
        },
        {
          path: 'step-3',
          name: 'wstep-3',
          component: () => import('./views/warranty/Step3.vue')
        },
        {
          path: 'step-4',
          name: 'wstep-4',
          component: () => import('./views/warranty/Step4.vue')
        },
      ]
    },
    {
      path: '/non-warranty',
      name: 'non-warranty',
      component: () => import('./views/non-warranty/Index.vue'),
      children: [
        {
          path: 'step-1',
          name: 'nwstep-1',
          component: () => import('./views/non-warranty/Step1.vue')
        },
        {
          path: 'step-2',
          name: 'nwstep-2',
          component: () => import('./views/non-warranty/Step2.vue')
        },
        {
          path: 'step-3',
          name: 'nwstep-3',
          component: () => import('./views/non-warranty/Step3.vue')
        },
        {
          path: 'step-4',
          name: 'nwstep-4',
          component: () => import('./views/non-warranty/Step4.vue')
        },
      ]
    },
    {
      path: '/payment/:id',
      name: 'payment',
      component: () => import('./views/Payment.vue')
    }
  ]
})
